import User from './models.user';
import Room from './models.room';
import Institution from './models.institution';

export default angular
  .module('doxy.global.models', [User, Room, Institution])
  .run(function (
    User,
    Room,
    Institution,
    UserMethods,
    RoomMethods,
    InstitutionMethods
  ) {
    Object.assign(User.prototype, UserMethods);
    Object.assign(Room.prototype, RoomMethods);
    Object.assign(Institution.prototype, InstitutionMethods);
  }).name;
